import { SVGProps } from "react";
import "./Logo.css";

const Logo = (props: SVGProps<SVGSVGElement>) => {
  const rootUrl = process.env["REACT_APP_API_URL"]?.replace(/\/+$/, "");

  return (
    <div className="logo-container">
      <img
        src={`${rootUrl}/branding/logo.svg`}
        alt="Logo"
        className="main-logo"
        id="desktop-logo"
      />
      <img
        src={`${rootUrl}/branding/logo-small.svg`}
        alt="Logo"
        className="main-logo"
        id="mobile-logo"
      />
    </div>
  );
};

export default Logo;
